import { b3dmHeaderSize } from './header';
import { B3dmFeatures, B3dmHeader } from './types';

export const extractB3dmFeatureTable = (
  b3DmBuffer: Buffer,
  b3DmHeader: B3dmHeader,
): B3dmFeatures => {
  const featureTableEndOffset = b3dmHeaderSize + b3DmHeader.featureTableJSONLength;
  const featureBinaryEndOffset = featureTableEndOffset + b3DmHeader.featureTableBinaryByteLength;
  const batchTableEndOffset = featureBinaryEndOffset + b3DmHeader.batchTableJSONByteLength;
  const batchBinaryEndOffset = batchTableEndOffset + b3DmHeader.batchTableBinaryByteLength;

  const featureTable = JSON.parse(
    b3DmBuffer.slice(b3dmHeaderSize, featureTableEndOffset).toString(),
  );
  const featureBody = Uint8Array.from(
    b3DmBuffer.slice(featureTableEndOffset, featureBinaryEndOffset),
  ).buffer;

  if (
    b3DmHeader.batchTableJSONByteLength > 0 &&
    b3DmHeader.batchTableBinaryByteLength > 0 &&
    b3DmBuffer.byteLength === batchBinaryEndOffset
  ) {
    return {
      featureTable,
      featureBody,
      batchTable: JSON.parse(
        b3DmBuffer.slice(featureBinaryEndOffset, batchTableEndOffset).toString(),
      ),
      batchBody: Uint8Array.from(b3DmBuffer.slice(batchTableEndOffset)).buffer,
    };
  }

  return { featureTable, featureBody };
};
